import React, { useCallback } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { CardView, rem } from 'design-system';
import Text from 'design-system/Text';
import { formatAmount } from 'utils';
import Links, { knownLinks } from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectPotProductFromProductId } from '../reducers/selectors';
const FSCSCard = ({ productId, text }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    const interestProduct = useAppSelector((store) => selectPotProductFromProductId(store, productId));
    const url = productId ? interestProduct?.fscsBrochure : knownLinks.FSCSprotection;
    const handleLearnMore = useCallback(() => {
        if (url) {
            if (Platform.OS === 'android' && url !== knownLinks.FSCSprotection) {
                navigateDeprecated('Pdf', { url, buttonTitle: 'Done' });
            }
            else {
                Links.openLink(url);
            }
        }
    }, [url]);
    return (<CardView style={styles.container} withPadding>
      <View style={styles.infoContainer}>
        <Text TextThin-14 centered Secondary>
          {text || 'Eligible deposits are protected by FSCS up to '}
          {!text ? (<Text NumbersThin-14 centered Secondary>
              {`${interestProduct?.maxFscsAmount ? formatAmount(interestProduct.maxFscsAmount, 'GBP') : '£120,000'}. `}
            </Text>) : null}
          {!!url && (<Text Primary Text-14 centered suppressHighlighting onPress={handleLearnMore}>
              Learn more
            </Text>)}
        </Text>
      </View>
    </CardView>);
};
export default FSCSCard;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: 'transparent',
        marginTop: rem(8),
        marginBottom: rem(8),
    },
    infoContainer: {
        flex: 1,
    },
});
